import React from 'react';
import PreviewLogo from '../assets/img/intro-mobile.png';

const HeroArea = () => {
  return (
    <header id="header-wrap">
      <div id="hero-area" className="hero-area-bg" style={{ paddingTop: '90px', paddingBottom: '60px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="contents">
                <h2 className="head-title lang-en">Welcome to Al-Buffia - Your Smart Office Refreshment SaaS</h2>
                <h2 className="head-title lang-ar" style={{ display: 'none' }}>البوفية - منصة SaaS سحابية لإدارة مشروبات المكتب</h2>

                <p className="lead lang-en">
                  Manage drinks, points and employee requests from one cloud platform. Each company gets its own subdomain - real-time kitchen orders, stock control and admin reports.
                  <br /><strong>Start a free trial today - no installation required.</strong>
                </p>
                <p className="lead lang-ar" style={{ display: 'none' }}>
                  إدارة المشروبات، النقاط، وطلبات الموظفين من منصة سحابية واحدة. كل شركة تحصل على نطاق فرعي - طلبات المطبخ مباشرة، تحكم في المخزون وتقارير للمدير.
                  <br /><strong>ابدأ تجربة مجانية الآن - بدون تثبيت.</strong>
                </p>

                <div className="header-button mt-3">
                  <a href="/register" className="btn btn-common lang-en">Start Free Trial</a>
                  <a href="/register" className="btn btn-common lang-ar" style={{ display: 'none' }}>ابدأ تجربتك المجانية</a>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="intro-img text-center">
                <img className="img-fluid" src={PreviewLogo} alt="Al-Buffia preview" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeroArea;
